import { render, staticRenderFns } from "./CheckListItemEditableDetailText.vue?vue&type=template&id=4e1e34d5&scoped=true&"
import script from "./CheckListItemEditableDetailText.vue?vue&type=script&lang=js&"
export * from "./CheckListItemEditableDetailText.vue?vue&type=script&lang=js&"
import style0 from "./CheckListItemEditableDetailText.vue?vue&type=style&index=0&id=4e1e34d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1e34d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
